<template>
  <div class="t-lk-promotions">
    <div class="t-lk-container">
      <div v-animation:bottom.delay class="t-lk-promotions__row t-lk-container-mobile">
        <h1 class="t-lk-title t-lk-promotions__title">{{ $root.staticText.lk.requestsTitle }}</h1>
        <div
          v-if="!isMobile"
          @click="
            modalType_requestOpen({
              options: optionsRequest,
              button: $root.staticText.forms.btn,
            })
          "
          class="t-btn _lk _green"
        >
          {{ $root.staticText.lk.requestTitle }}
        </div>
        <div
          v-else
          @click="
            modalType_requestOpen({
              options: optionsRequest,
              button: $root.staticText.forms.btn,
            })
          "
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5L5 5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7L3 17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z"
              stroke="#00b0bd"
              stroke-width="1.68"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>

      <div v-animation:bottom.delay class="t-lk-promotions-completed t-lk-requests__container">
        <div v-animation:bottom.delay class="t-lk-promotions-completed__row">
          <lk-search-cmp :obj-undefined="{ currentPage: undefined }"> </lk-search-cmp>
          <filter-cmp
            v-if="filter"
            class="t-lk-promotions-completed__filter"
            :filter="filter"
            :obj-undefined="{ currentPage: undefined }"
            :name-btn="$root.staticText.lk.requestsFilterBtn"
            :is-date="true"
          >
          </filter-cmp>
        </div>
        <div class="t-lk-promotions-completed-table">
          <div v-animation:bottom.delay class="t-lk-promotions-completed-table__row _first">
            <div class="t-lk-promotions-completed-table__th t-lk-promotions-completed-table__td" v-for="item in requestsTitle">
              {{ item }}
            </div>
          </div>
          <div class="js-requests">
            <div
              v-animation:bottom.delay
              v-for="item in requests"
              class="t-lk-promotions-completed-table__row t-lk-requests__row"
              :class="{ _green: item.notification }"
            >
              <div class="t-lk-promotions-completed-table__td t-lk-requests__td">
                <div class="t-lk-promotions-completed-table__name t-lk-requests__name">
                  {{ item.name }}
                </div>
                <div v-if="item.notification" class="t-lk-requests__notification">
                  {{ item.notification }}
                </div>
              </div>
              <div class="t-lk-promotions-completed-table__td ">
                <div class="t-lk-promotions-completed-table__date">{{ item.date }}</div>
              </div>
              <div class="t-lk-promotions-completed-table__td ">
                <div v-if="item.status === 'done'" class="t-lk-promotions-completed-table__status t-lk-requests__status _done">
                  {{ $root.staticText.lk.requestsStatusDone }}
                </div>
                <div v-if="item.status === 'answer'" class="t-lk-promotions-completed-table__status t-lk-requests__status _done">
                  {{ $root.staticText.lk.requestsStatusAnswer }}
                </div>
                <div v-else-if="item.status === 'wait'" class="t-lk-promotions-completed-table__status t-lk-requests__status">
                  {{ $root.staticText.lk.requestsStatusWait }}
                </div>
              </div>
              <div class="t-lk-promotions-completed-table__td t-lk-requests__last">
                <router-link v-if="item.status === 'done'" :to="item.link" class="t-lk-requests__btn">
                  <div class="t-btn _lk _border-gray">{{ $root.staticText.lk.requestsStatusDoneBtn }}</div>
                  <div class="t-btn _lk _border-gray t-lk-requests__btn-svg">
                    <svg width="10" height="24" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M1.60254 1.39746L8.60254 8.39746L1.60254 15.3975"
                        stroke="black"
                        stroke-width="1.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </router-link>
                <router-link v-if="item.status === 'wait' || item.status === 'answer'" :to="item.link" class="t-lk-requests__btn">
                  <div class="t-btn _lk _border-gray">{{ $root.staticText.lk.requestsStatusWaitBtn }}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination-cmp
        v-animation:bottom.delay
        v-if="pagination"
        :pagination="pagination"
        :name-current-page="'currentPage'"
        class="t-lk-requests__pag _lk"
      >
      </pagination-cmp>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import lkSearch from '@components/lk/lk-search/lk-search.vue'
import filter from '@components/lk/lk-filter/lk-filter.vue'
import pagination from '@components/ui-components/pagination/pagination.vue'

import onScrollAnimate from '@assets/js/scrollAnimate.js'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'lk-requests',
  data() {
    return {
      optionsRequest: null,
      filter: null,
      requestsTitle: [
        this.$root.staticText.lk.promotionsCompletedTable,
        this.$root.staticText.lk.promotionsCompletedTable2,
        this.$root.staticText.lk.promotionsCompletedTable3,
        '',
      ],
      requests: [],
      pagination: null,
      updateUrl: true,
    }
  },
  components: {
    'lk-search-cmp': lkSearch,
    'filter-cmp': filter,
    'pagination-cmp': pagination,
  },
  computed: {
    ...mapState('mobile', ['isMobile', 'isTablet']),
  },
  methods: {
    ...mapActions('modal', ['modalType_requestOpen']),

    setData(data) {
      this.optionsRequest = data.optionsRequest
      this.filter = data.filter
      this.requests = data.requests
      this.pagination = data.pagination
    },
  },
  beforeRouteUpdate(to, from, next) {
    let url = process.env.NODE_ENV !== 'production' ? 'lk/requestsPage.json' : 'lk/requests'

    if (to.query.update) {
      this.$router.push({
        name: this.$route.name,
        query: Object.assign({}, this.$route.query, { update: undefined }),
      })
      this.updateUrl = false
      setTimeout(() => {
        this.updateUrl = true
      }, 500)

      Vue.http.get(url, { params: to.query }).then(
        data => {
          this.setData(data.data)
          next()
          setTimeout(() => {
            onScrollAnimate()
          }, 500)
        },
        data => {
          if (data.status === 403) {
            next({ name: 'E403' })
          } else {
            next({ name: 'E404' })
          }
        }
      )
    } else if (!from.query.update && this.updateUrl) {
      this.$root.setDataAnimateFalse('.js-requests ')

      Vue.http.get(url, { params: to.query }).then(
        data => {
          this.setData(data.data)
          next()
          setTimeout(() => {
            onScrollAnimate()
          }, 500)
        },
        data => {
          if (data.status === 403) {
            next({ name: 'E403' })
          } else {
            next({ name: 'E404' })
          }
        }
      )
    }
  },
  beforeRouteEnter(to, from, next) {
    let url = process.env.NODE_ENV !== 'production' ? 'lk/requestsPage.json' : 'lk/requests'
    Vue.http.get(url, { params: to.query }).then(
      data => {
        next(vm => vm.setData(data.data))
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/lk/requests/index.vue